import React from 'react';
import { cn } from '../../utils';

const statusStyles = {
    Pending: { text: 'text-amber-700', dot: 'bg-amber-500' },
    Approved: { text: 'text-emerald-700', dot: 'bg-yavrio-green' },
    Rejected: { text: 'text-red-700', dot: 'bg-red-500' },
    Failed: { text: 'text-red-800', dot: 'bg-red-600' },
    Processing: { text: 'text-slate-600', dot: 'bg-slate-400' },
};

export default function PaymentStatus({ status, className }) {
    const styles = statusStyles[status] || { text: 'text-slate-600', dot: 'bg-slate-400' };
    return (
        <div className="flex items-center gap-2">
            <span className={`h-2 w-2 rounded-full shrink-0 ${styles.dot}`} />
            <span className={cn('font-medium', styles.text, className ?? 'text-sm')}>{status}</span>
        </div>
    );
}
